import axios from "axios";

export default {
    getArticles(work_shop_id, { current_page = 1, per_page = 20, data = {} }) {
        return axios.get(
            `/api/${work_shop_id}/articles/${current_page}/${per_page}`,
            { params: { ...data } }
        );
    },

    getArticle(work_shop_id, { id }) {
        return axios.get(`/api/${work_shop_id}/articles/${id}`);
    },

    deleteArticle(work_shop_id, { id }) {
        return axios.delete(`/api/${work_shop_id}/articles/${id}`);
    }
};
